// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"561":"47afd51c","598":"0b565fb6","779":"90c2da20"}[chunkId] + ".chunk.css";
};